function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useContext } from "react";
import PropTypes from "prop-types";
import Button from "../button/Button";
import { Save, Cancel } from "../../icons";
import { Context } from "./Modal";
const ModalFooter = _ref => {
  let {
    saveButton,
    closeButton,
    onSubmit,
    children,
    saveButtonProps,
    closeButtonProps,
    saveButtonText,
    closeButtonText,
    ...props
  } = _ref;
  const context = useContext(Context);
  return /*#__PURE__*/React.createElement("div", _extends({}, props, {
    className: `tui-modal-footer ${props.className}`,
    style: props.style
  }), children, saveButton && /*#__PURE__*/React.createElement(Button, _extends({
    variant: "confirm",
    icon: {
      type: "left",
      render: () => /*#__PURE__*/React.createElement(Save, null)
    },
    onClick: onSubmit,
    className: "save",
    disabled: context.isLoading,
    isLoading: context.isSubmitting
  }, saveButtonProps), saveButtonText), closeButton && /*#__PURE__*/React.createElement(Button, _extends({
    variant: "destructive",
    outline: true,
    icon: {
      type: "left",
      render: () => /*#__PURE__*/React.createElement(Cancel, null)
    },
    className: "cancel",
    onClick: context.onCancel,
    disabled: context.isLoading || context.isSubmitting
  }, closeButtonProps), closeButtonText));
};
ModalFooter.displayName = "ModalFooter";
ModalFooter.defaultProps = {
  style: {},
  className: "",
  saveButton: false,
  closeButton: false,
  children: undefined,
  onSubmit: () => {},
  saveButtonProps: {},
  closeButtonProps: {},
  saveButtonText: "Save",
  closeButtonText: "Cancel"
};
ModalFooter.propTypes = {
  style: PropTypes.object,
  className: PropTypes.string,
  saveButton: PropTypes.bool,
  closeButton: PropTypes.bool,
  children: PropTypes.node,
  onSubmit: PropTypes.func,
  saveButtonProps: PropTypes.object,
  closeButtonProps: PropTypes.object,
  saveButtonText: PropTypes.string,
  closeButtonText: PropTypes.string
};
export default ModalFooter;
//# sourceMappingURL=ModalFooter.js.map